import BaseModel from '@/models/BaseModel.js'

export default class District extends BaseModel {
    endpoint = process.env.VUE_APP_API_URL + 'area/districts'
}